import { Grid } from '@material-ui/core';
import { DefaultCard } from 'design-system';
// models
import { Quotation } from 'data-layer-cr/dist/models';
// funtions
import { getIndexFromPackageOption } from 'src/functions/individualOptionHelpers';
// components
import IndividualPriceDetail from 'src/components/screens/components/IndividualPriceDetail';

type Props = {
  quotation: Quotation;
};

const PackageCard = ({ quotation }: Props): JSX.Element => {
  const {
    packageOption,
    quotationProfile: { typeOfMoney },
  } = quotation;
  const selectecUnit =
    quotation.units[getIndexFromPackageOption(packageOption)];
  const profileType = quotation.quotationProfile.type;

  return (
    <DefaultCard data-testid="package-card">
      <Grid container justifyContent="center">
        <Grid container item xs={12} md={8} lg={6}>
          <IndividualPriceDetail
            data-testid="individual-price-detail"
            anualPrice={selectecUnit.total.grandTotal}
            moneyType={typeOfMoney}
            packageOption={packageOption}
            profileType={profileType}
          />
        </Grid>
      </Grid>
    </DefaultCard>
  );
};

export default PackageCard;
